var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"before-close":_vm.handleClose,"width":_vm.width,"close-on-click-modal":false,"center":"","title":"","append-to-body":""},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('MenberVipInner',{ref:"MenberVipInnerRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }